/* ============================================================================
 * Provador Virtual — Base de dados de conversão de tamanhos
 * ----------------------------------------------------------------------------
 * - charts: cartelas OFICIAIS por marca (marca -> gênero -> {BR: comprimento do pé cm}).
 *   Nike = oficial (static.nike.com.br). Demais marcas usam a curva 'padrao'
 *   (gênero-aware, calibrada por dados atléticos) até termos a cartela oficial.
 * - brToFootCm: conversão NEUTRA usada só para o fallback do lado do PRODUTO
 *   (quando o produto não tem o metafield custom.provador_tamanhos).
 * As medidas finais de cada PRODUTO vêm do metafield (ver snippet).
 * ========================================================================== */
(function () {
  'use strict';

  function round1(n) {
    return n == null ? null : Math.round(n * 10) / 10;
  }
  function interp(x0, y0, x1, y1, x) {
    if (x1 === x0) return y0;
    return y0 + ((y1 - y0) * (x - x0)) / (x1 - x0);
  }
  /* lookup com interpolação/extrapolação linear numa tabela {BR: cm} */
  function lookup(table, size) {
    if (table[size] != null) return table[size];
    var keys = Object.keys(table).map(Number).sort(function (a, b) { return a - b; });
    if (!keys.length) return null;
    if (size <= keys[0]) return interp(keys[0], table[keys[0]], keys[1], table[keys[1]], size);
    var last = keys.length - 1;
    if (size >= keys[last]) return interp(keys[last - 1], table[keys[last - 1]], keys[last], table[keys[last]], size);
    for (var i = 0; i < last; i++) {
      if (size >= keys[i] && size <= keys[i + 1]) {
        return interp(keys[i], table[keys[i]], keys[i + 1], table[keys[i + 1]], size);
      }
    }
    return null;
  }

  /* Conversão NEUTRA (lado do produto / fallback): footCm = 0,667*BR - 0,67 */
  function brToFootCm(brSize) {
    var n = parseFloat(String(brSize).replace(',', '.'));
    if (isNaN(n)) return null;
    return round1(0.667 * n - 0.67);
  }

  function buildSizeGrid(min, max) {
    var grid = [];
    for (var s = min; s <= max + 0.001; s += 0.5) grid.push(Number(s.toFixed(1)));
    return grid;
  }

  window.ProvadorData = {
    brToFootCm: brToFootCm,

    sizeGrid: {
      feminino: buildSizeGrid(33, 43),
      masculino: buildSizeGrid(37, 46)
    },

    brands: [
      { name: 'Nike', popular: true }, { name: 'Adidas', popular: true },
      { name: 'Vans', popular: true }, { name: 'Puma', popular: true },
      { name: 'Reebok', popular: true }, { name: 'New Balance', popular: true },
      { name: 'Asics', popular: true }, { name: 'Skechers', popular: true },
      { name: 'Alexandre Birman' }, { name: 'Arezzo' }, { name: 'Birkenstock' },
      { name: 'Bloch' }, { name: 'Capodarte' }, { name: 'Carmen Steffens' },
      { name: 'Clarks' }, { name: 'Crocs' }, { name: 'Diadora' }, { name: 'Dr Martens' },
      { name: 'Fila' }, { name: 'Havaianas' }, { name: 'Hoka' }, { name: 'Jorge Bischoff' },
      { name: 'Kappa' }, { name: 'Larroudé' }, { name: 'Luiza Barcelos' }, { name: 'Melissa' },
      { name: 'Mississipi' }, { name: 'Mizuno' }, { name: 'Modare' }, { name: 'Moleca' },
      { name: 'Monopólio Shoes' }, { name: 'Olympikus' }, { name: 'Piccadilly' },
      { name: 'Ramarim' }, { name: 'Salomon' }, { name: 'Santa Lolla' }, { name: 'Schutz' },
      { name: 'Timberland' }, { name: 'Under Armour' }, { name: 'Usaflex' }
    ],

    /* marca -> chave de cartela. Sem entrada = usa 'padrao'. */
    brandCharts: {
      Nike: 'nike',
      Puma: 'puma',
      Asics: 'asics',
      'New Balance': 'newbalance',
      Adidas: 'adidas',
      Vans: 'vans',
      Skechers: 'skechers',
      Mizuno: 'mizuno',
      Olympikus: 'olympikus',
      Havaianas: 'havaianas',
      Usaflex: 'usaflex',
      Reebok: 'reebok',
      Arezzo: 'arezzo',
      Melissa: 'melissa',
      Piccadilly: 'piccadilly'
    },

    /* Cartelas: BR -> comprimento do pé (cm). Todas em COMPRIMENTO DO PÉ
     * (mesma medida da tabela do produto), não palmilha. */
    charts: {
      // OFICIAL Arezzo (modal "Guia de tamanhos" da PDP arezzo.com.br, jul/26; instrução manda
      // medir o pé calcanhar→dedão). Marca feminina — sem tabela masc (masc cai na curva padrão).
      arezzo: {
        feminino: { 33: 22.0, 34: 22.6, 35: 23.3, 36: 24.0, 37: 24.6, 38: 25.3, 39: 26.0, 40: 26.6 }
      },
      // OFICIAL Melissa (modal "Tabela de Medidas ADULTO" da PDP melissa.com.br, jul/26). Tabela
      // única adulto (unissex). Grupos 33/34=22, 39/40=26 e 43/44=29 expandidos em ±0,2 por número;
      // 40 tinha linha própria (26,5) além do grupo.
      melissa: {
        feminino: { 33: 21.8, 34: 22.2, 35: 23.0, 36: 24.0, 37: 25.0, 38: 25.5, 39: 26.0, 40: 26.5, 41: 27.0, 42: 28.0, 43: 28.8, 44: 29.2 },
        masculino: { 33: 21.8, 34: 22.2, 35: 23.0, 36: 24.0, 37: 25.0, 38: 25.5, 39: 26.0, 40: 26.5, 41: 27.0, 42: 28.0, 43: 28.8, 44: 29.2 }
      },
      // OFICIAL Piccadilly (modal "Guia de tamanhos" da PDP piccadilly.com.br, jul/26; aba "Como
      // medir" manda medir O PÉ na parede). Faixas → ponto médio. A numeração deles VESTE GRANDE
      // (38 = pé 25,8-26,4) — é isso mesmo, conferido na fonte oficial; tabelas de revenda divergem.
      piccadilly: {
        feminino: { 33: 22.4, 34: 23.4, 35: 24.1, 36: 24.7, 37: 25.4, 38: 26.1, 39: 26.8, 40: 27.4, 41: 28.1, 42: 28.8 }
      },
      // OFICIAL Nike Brasil (static.nike.com.br/web/prd/tabela-de-medidas.html)
      nike: {
        feminino: { 33.5: 22.0, 34: 22.4, 35: 22.9, 35.5: 23.3, 36: 23.7, 37: 24.1, 37.5: 24.5, 38: 25.0, 39: 25.4, 39.5: 25.8, 40: 26.2, 41: 26.7, 41.5: 27.1, 42: 27.5, 43: 27.9 },
        masculino: { 34: 21.6, 34.5: 22.0, 35: 22.4, 35.5: 22.9, 36: 23.3, 37: 23.7, 37.5: 24.1, 38: 24.5, 39: 25.0, 39.5: 25.4, 40: 25.8, 40.5: 26.2, 41: 26.7, 42: 27.1, 42.5: 27.5, 43: 27.9, 43.5: 28.3, 44: 28.8, 45: 29.2, 46: 29.6 }
      },
      // OFICIAL Puma Brasil (br.puma.com/guia-de-medidas.html)
      puma: {
        feminino: { 34: 22.5, 35: 23.0, 35.5: 23.5, 36: 24.0, 36.5: 24.5, 37: 25.0, 38: 25.5, 38.5: 26.0, 39: 26.5, 40: 27.0, 40.5: 27.5 },
        masculino: { 34: 22.0, 35: 23.0, 35.5: 23.5, 36: 24.0, 36.5: 24.5, 37: 25.0, 38: 25.5, 38.5: 26.0, 39: 26.5, 40: 27.0, 40.5: 27.5, 41: 28.0, 42: 28.5, 42.5: 29.0, 43: 29.5, 44.5: 30.0, 45: 31.0, 46: 32.0 }
      },
      // OFICIAL Asics Brasil (asics.com.br/ajuda/guia-medidas) — comprimento do pé
      asics: {
        feminino: { 31: 20.5, 32: 21.5, 33: 22.5, 34: 22.75, 35: 23.0, 35.5: 23.5, 36: 24.0, 37: 24.5, 37.5: 25.0, 38: 25.5, 39: 25.75, 39.5: 26.0, 40: 26.5, 40.5: 27.0, 41: 27.5, 41.5: 28.0, 42: 28.5, 43: 29.0, 43.5: 29.5, 44: 30.0 },
        masculino: { 34: 22.5, 35: 23.0, 35.5: 23.5, 36: 24.0, 36.5: 24.5, 37: 25.0, 37.5: 25.25, 38: 25.5, 39: 26.0, 39.5: 26.5, 40: 27.0, 41: 27.5, 41.5: 28.0, 42: 28.25, 42.5: 28.5, 43: 29.0, 44: 29.5, 45: 30.0, 46: 30.5, 47: 31.0, 48: 32.0 }
      },
      // OFICIAL New Balance Brasil — tabela ÚNICA (mesma p/ fem e masc), comprimento do pé
      newbalance: {
        feminino: { 34: 22.5, 35: 23.0, 36: 23.5, 37: 24.0, 38: 24.5, 39: 25.0, 40: 26.0, 41: 26.8, 42: 27.0, 43: 28.0, 44: 29.0, 45: 29.8, 46: 30.5 },
        masculino: { 34: 22.5, 35: 23.0, 36: 23.5, 37: 24.0, 38: 24.5, 39: 25.0, 40: 26.0, 41: 26.8, 42: 27.0, 43: 28.0, 44: 29.0, 45: 29.8, 46: 30.5 }
      },
      // OFICIAL Adidas Brasil (guia de tamanhos) — tabela ÚNICA (fem/masc igual em BR), comprimento do pé
      adidas: {
        feminino: { 33: 21.6, 34: 22.5, 35: 22.9, 36: 23.8, 37: 24.2, 38: 24.6, 39: 25.0, 40: 25.9, 41: 26.7, 42: 27.1, 43: 28.0, 44: 28.8, 45: 29.3, 46: 30.1, 47: 31.0 },
        masculino: { 33: 21.6, 34: 22.5, 35: 22.9, 36: 23.8, 37: 24.2, 38: 24.6, 39: 25.0, 40: 25.9, 41: 26.7, 42: 27.1, 43: 28.0, 44: 28.8, 45: 29.3, 46: 30.1, 47: 31.0 }
      },
      // Vans Brasil — fonte dá PALMILHA; convertido p/ comprimento do pé (−1,2 cm). Unissex.
      vans: {
        feminino: { 33: 20.3, 34: 20.8, 35: 21.3, 36: 22.3, 37: 23.3, 38: 24.3, 39: 25.3, 40: 25.8, 41: 26.8, 42: 27.3, 43: 27.8, 44: 28.8, 45: 29.8, 46: 30.8 },
        masculino: { 33: 20.3, 34: 20.8, 35: 21.3, 36: 22.3, 37: 23.3, 38: 24.3, 39: 25.3, 40: 25.8, 41: 26.8, 42: 27.3, 43: 27.8, 44: 28.8, 45: 29.8, 46: 30.8 }
      },
      // OFICIAL Skechers (Amazon, "BR Regulares") — comprimento do pé. Unissex.
      skechers: {
        feminino: { 37: 24.5, 38: 25.0, 39: 26.0, 40: 26.5, 41: 27.5, 42: 28.0, 43: 29.0, 44: 30.0, 45: 31.0, 46: 32.0 },
        masculino: { 37: 24.5, 38: 25.0, 39: 26.0, 40: 26.5, 41: 27.5, 42: 28.0, 43: 29.0, 44: 30.0, 45: 31.0, 46: 32.0 }
      },
      // OFICIAL Mizuno — comprimento do pé. Unissex.
      mizuno: {
        feminino: { 34: 23.0, 35: 23.5, 36: 24.0, 37: 24.5, 38: 25.0, 39: 25.5, 40: 26.5, 41: 27.5, 42: 28.0, 43: 29.0, 44: 30.0 },
        masculino: { 34: 23.0, 35: 23.5, 36: 24.0, 37: 24.5, 38: 25.0, 39: 25.5, 40: 26.5, 41: 27.5, 42: 28.0, 43: 29.0, 44: 30.0 }
      },
      // OFICIAL Olympikus — comprimento do pé. Unissex.
      olympikus: {
        feminino: { 35: 23.4, 36: 24.0, 37: 24.7, 38: 25.4, 39: 26.0, 40: 26.7, 41: 27.4, 42: 28.0, 43: 28.7, 44: 29.4, 45: 30.0, 46: 30.7, 47: 31.4, 48: 32.0 },
        masculino: { 35: 23.4, 36: 24.0, 37: 24.7, 38: 25.4, 39: 26.0, 40: 26.7, 41: 27.4, 42: 28.0, 43: 28.7, 44: 29.4, 45: 30.0, 46: 30.7, 47: 31.4, 48: 32.0 }
      },
      // OFICIAL Havaianas — chinelo, tamanho AGRUPADO (33/34, 35/36...) c/ faixa de cm; nº avulso = ponto na faixa do grupo.
      havaianas: {
        masculino: { 35: 22.7, 36: 23.3, 37: 24.0, 38: 24.7, 39: 25.4, 40: 26.0, 41: 26.7, 42: 27.3, 43: 28.0, 44: 28.7, 45: 29.4, 46: 30.0, 47: 30.7, 48: 31.3 },
        feminino: { 33: 21.4, 34: 22.0, 35: 22.7, 36: 23.3, 37: 24.0, 38: 24.7, 39: 25.4, 40: 26.0, 41: 26.7, 42: 27.3 }
      },
      // OFICIAL Usaflex — chinelo, nº avulso c/ faixa de cm (uso o ponto médio).
      // FEMININO oficial; MASCULINO espelhado (placeholder — falta o print do tab Masculino, se vender).
      usaflex: {
        feminino: { 33: 22.4, 34: 23.0, 35: 23.7, 36: 24.4, 37: 25.0, 38: 25.7, 39: 26.4, 40: 27.0, 41: 27.7, 42: 28.4 },
        masculino: { 33: 22.4, 34: 23.0, 35: 23.7, 36: 24.4, 37: 25.0, 38: 25.7, 39: 26.4, 40: 27.0, 41: 27.7, 42: 28.4 }
      },
      // OFICIAL Reebok (Guia de Medidas - Tênis Unissex) — comprimento do pé. Unissex.
      reebok: {
        feminino: { 34: 23.3, 35: 23.5, 35.5: 23.6, 36: 24.0, 37: 24.5, 38: 25.0, 39: 25.5, 39.5: 26.0, 40: 26.5, 40.5: 27.0, 41: 27.5, 42: 28.0, 42.5: 28.5, 43: 29.0, 43.5: 29.5, 44: 30.0, 45: 30.5, 45.5: 31.0, 46: 31.5 },
        masculino: { 34: 23.3, 35: 23.5, 35.5: 23.6, 36: 24.0, 37: 24.5, 38: 25.0, 39: 25.5, 39.5: 26.0, 40: 26.5, 40.5: 27.0, 41: 27.5, 42: 28.0, 42.5: 28.5, 43: 29.0, 43.5: 29.5, 44: 30.0, 45: 30.5, 45.5: 31.0, 46: 31.5 }
      }
    },

    /* Curva PADRÃO gênero-aware (calibrada pela cartela atlética).
     * feminino: 0,6*BR + 2,2 | masculino: 0,65*BR - 0,2 */
    getFootCm: function (brand, gender, size) {
      var g = gender === 'masculino' ? 'masculino' : 'feminino';
      var n = parseFloat(String(size).replace(',', '.'));
      if (isNaN(n)) return null;
      var key = this.brandCharts[brand];
      if (key && this.charts[key] && this.charts[key][g]) {
        return round1(lookup(this.charts[key][g], n));
      }
      return round1(g === 'masculino' ? 0.65 * n - 0.2 : 0.6 * n + 2.2);
    },

    /* Medidas REAIS por produto (cm por tamanho do site), chaveado pelo handle.
     * Usado quando o produto NÃO tem o metafield custom.provador_tamanhos.
     * Adicionar produto = adicionar uma entrada aqui (ou preencher o metafield). */
    productRanges: {
      // Sandália Anatômica Pé de Algodão (tabela "Anatômica")
      'sandalia-anatomica-pe-de-algodao': {
        '34/35': [22.6, 23.5], '36/37': [23.6, 24.5], '38/39': [24.6, 25.5],
        '40/41': [25.6, 26.5], '42/43': [26.6, 27.5], '44/45': [27.6, 28.5], '46/47': [28.6, 29.5]
      }
    },

    /* ajuste fino por marca em cm (raramente necessário; chart já encode a marca) */
    brandOffsets: {},

    /* "como calça o comprimento": desloca a estimativa do pé (cm) */
    fitAdjustCm: { justo: 0.4, na_medida: 0, folgado: -0.4 },

    /* "formato do pé": desempate em fronteira (não altera o comprimento) */
    widthTieBreak: { estreito: -1, medio: 0, largo: 1 }
  };
})();
